import React from "react";
import { cn } from "@/utils";

interface StepIndicatorProps {
  currentStep: number;
  totalSteps: number;
  stepTitles?: string[];
}

export function StepIndicator({ currentStep, totalSteps, stepTitles }: StepIndicatorProps) {
  return (
    <div className="w-full mb-6">
      <div className="flex justify-between">
        {Array.from({ length: totalSteps }).map((_, index) => {
          const stepNumber = index + 1;
          const isActive = stepNumber === currentStep;
          const isCompleted = stepNumber < currentStep;
          
          return (
            <div key={index} className="flex flex-col items-center">
              <div 
                className={cn(
                  "flex items-center justify-center w-8 h-8 rounded-full border-2 mb-2 transition-colors",
                  isActive && "border-primary bg-primary text-primary-foreground",
                  isCompleted && "border-primary bg-primary/20 text-primary",
                  !isActive && !isCompleted && "border-muted-foreground text-muted-foreground"
                )}
              >
                {stepNumber}
              </div>
              {stepTitles && (
                <span className={cn(
                  "text-xs font-medium text-center",
                  isActive && "text-primary",
                  isCompleted && "text-primary/80",
                  !isActive && !isCompleted && "text-muted-foreground"
                )}>
                  {stepTitles[index]}
                </span>
              )}
            </div>
          );
        })}
      </div>
      <div className="relative mt-2">
        <div className="absolute top-0 h-1 bg-muted w-full rounded-full" />
        <div 
          className="absolute top-0 h-1 bg-primary rounded-full transition-all duration-300"
          style={{ width: `${((currentStep - 1) / (totalSteps - 1)) * 100}%` }}
        />
      </div>
    </div>
  );
}